export default __webpack_public_path__ + "static/media/New Project (1).f58d01f0.png";